import { render } from "./Header.vue?vue&type=template&id=401db99e&scoped=true&lang=pug"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=401db99e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-401db99e"

export default script